import $ from 'jquery';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;

function ZoneHistoryDatePicker(props) {

    let start_date = props.date ? moment(props.date, 'YYYY-MM-DD').startOf('day') : moment();
    let end_date = props.end_date ? moment(props.end_date, 'YYYY-MM-DD').startOf('day') : moment();

    const [date_range, setDateRange] = useState(props.date_range);
    const [dates, setDates] = useState([start_date, end_date]);
    const [defaults, setDefaults] = useState([start_date, end_date]);

    useEffect(() => {
        $('.datepicker').attr('readonly', 'true');
        let start_date = props.date ? moment(props.date, 'YYYY-MM-DD').startOf('day') : moment();
        let end_date = props.end_date ? moment(props.end_date, 'YYYY-MM-DD').startOf('day') : moment();

        setDateRange(props.date_range);
        setDates([start_date, end_date])
        setDefaults([start_date, end_date])

    }, [props]);

    const showHistory = (m) => {
        m({
            start_date: dates[0].format('YYYY-MM-DD'),
            end_date: dates[1].format('YYYY-MM-DD')
        });
    }

    const disabledDate = (current) => {
        return current <= date_range[0] || current >= date_range[1];
    }

    const handleInput = (val) => {
        if (val) {
            let today = moment().startOf('day');
            if (val[0] && !val[1]) {
                let next6 = moment(val[0].format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day').add(6, 'days');
                val[1] = next6 > today ? today : next6;
            } else if (!val[0] && val[1]) {
                val[0] = moment(val[1].format('YYYY-MM-DD'), 'YYYY-MM-DD').add(-6, 'days');
            } else if (val[1].diff(val[0], 'days') > 6) {
                let next6 = moment(val[0].format('YYYY-MM-DD'), 'YYYY-MM-DD').startOf('day').add(6, 'days');
                val[1] = next6 > today ? today : next6;
            }

            setDates(val);
        } else {
            setDates(defaults);
        }
    }

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-12 text-right">
                    <span>Choose Date Range : &nbsp;</span>
                    <RangePicker disabledDate={disabledDate} value={dates} onChange={(obj) => handleInput(obj, 'start_end_dates')} />
                    <button disabled={dates.length < 2 || !dates[0] || !dates[1]} className="btn btn-sm btn-primary" style={{ lineHeight: '23px', marginBottom: '2px', borderTopLeftRadius: '0px', borderBottomLeftRadius: '0px' }} onClick={() => showHistory(props.onSubmit)}>GO</button>
                </div>
            </div>
        </React.Fragment >
    );
}

export default ZoneHistoryDatePicker;